export default function app(
  state = {
    user: null,
    snackbar: {
      message: "",
      options: {
        undoAction: "",
        time: 0,
        showClose: false,
        showUndo: false,
      },
    },
  },
  action,
) {
  switch (action.type) {
    case "CHANGE_USER":
      return { ...state, user: action.payload }
    case "CHANGE_SNACKBAR":
      return { ...state, snackbar: { ...state.snackbar, ...action.payload } }
    default:
      return state
  }
}
